<template>
  <div class="main">

    <p>slick デフォルト ↓</p>
		<slick ref="slick" class="slick-outer">
      <div><img src="static/img/tokyost.jpg" class="slick-img">{{tokyo}}</div>
      <div><img src="static/img/osaka.jpg" class="slick-img">{{osaka}}</div>
      <div><img src="static/img/aso.jpg" class="slick-img">{{aso}}</div>
    </slick>

   <p>slick オプション指定 ↓</p>
    <slick ref="slick" :options="slickOptions" class="slick-outer">
      <div><img src="static/img/tokyost.jpg" class="slick-img">{{tokyo}}</div>
      <div><img src="static/img/osaka.jpg" class="slick-img">{{osaka}}</div>
      <div><img src="static/img/aso.jpg" class="slick-img">{{aso}}</div>
    </slick>

  </div>
</template>

<script>
import Slick from 'vue-slick'
import '../../node_modules/slick-carousel/slick/slick.css'
export default {
  name: 'Main',
  data () {
    return {
      tokyo: '東京駅',
      osaka: '大阪城',
      aso: '阿蘇山',
      slickOptions:{
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1000,
      }
    }
  },
  components: {
    Slick
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.slick-outer{
  width:80%;
  padding:10px;
  margin:auto;
    margin-bottom:10px;
    background-color:lightgray;
}
.slick-img{
  margin:auto;
  width:50%;
  height:250px;
}

@media(max-width:768px) {
.slick-img{
  margin:auto;
  width:50%;
  height:150px;
}
}

</style>


// WEBPACK FOOTER //
// src/components/Main.vue